import { useAppDispatch, useAppSelector } from 'modules/hooks/appHooks';
import { ToastProps } from 'modules/ui/toast/Toast';
import { useCallback } from 'react';
import { ToastContainerSelectors } from '../redux';
import { addToast, clearAllToasts, removeToast } from '../redux/slice';

export const useToastContainer = () => {
  const dispatch = useAppDispatch();

  const activeToasts = useAppSelector(
    ToastContainerSelectors.selectActiveToasts,
  );

  const getActiveToasts = useCallback(() => activeToasts, [activeToasts]);

  const addToastMessage = useCallback(
    (toastProps: ToastProps) => {
      // If toast id is not provided, it is generated
      const id = toastProps.id || toastProps.title + Date.now();
      dispatch(addToast({ ...toastProps, id }));
    },
    [dispatch],
  );

  const removeToastMessage = useCallback(
    (id: string) => {
      dispatch(removeToast(id));
    },
    [dispatch],
  );

  const clearAllToastMessages = useCallback(() => {
    dispatch(clearAllToasts());
  }, [dispatch]);

  return {
    activeToasts: getActiveToasts(),
    addToast: addToastMessage,
    removeToast: removeToastMessage,
    clearAllToasts: clearAllToastMessages,
  };
};
